import React, { FunctionComponent } from 'react';
import styles from './countdown-component.module.scss';

type CountdownProps = {
  /** from 0 up to 20 */
  count: number;
  /** in px */
  width?: number;
  /** in px */
  height?: number;
  background?: 'white' | 'grey';
};

/**
 * Countdown component
 *
 * https://www.figma.com/file/jiN4FkdkhDZIWxIkPS6Ru7/design-system?node-id=33%3A258
 */
export const Countdown: FunctionComponent<CountdownProps> = ({ width = 24, height = 24, background = 'white', ...props }) => {
  //lightest grey or white
  const backgroundFill = background === 'grey' ? '#f7f7f7' : 'white';

  return (
    <div className={styles['countdown-component']}>
      <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='10' fill={backgroundFill} />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
          fill='#DFD3EC'
        />
        {getCountDisplay(props.count)};
      </svg>
    </div>
  );

  function getCountDisplay(count: number) {
    switch (count) {
      case 0: {
        return (
          <>
            <path
              d='M8.29179 0.587322C9.48939 0.198199 10.7408 -1.50161e-08 12 0V1.99073C10.9497 1.99073 9.90589 2.15605 8.90697 2.48062L8.29179 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 2.29179C5.96532 1.55164 7.0942 0.976443 8.2918 0.58732L8.90697 2.48062C7.90805 2.80519 6.96644 3.28496 6.1167 3.90233L4.94658 2.29179Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 4.94658C3.03195 3.92784 3.92785 3.03195 4.94658 2.29179L6.11671 3.90233C5.26697 4.5197 4.5197 5.26696 3.90233 6.1167L2.2918 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M0.587323 8.29179C0.976446 7.0942 1.55164 5.96531 2.2918 4.94657L3.90233 6.1167C3.28497 6.96643 2.80519 7.90804 2.48062 8.90696L0.587323 8.29179Z'
              fill='#5F259F'
            />
            <path
              d='M0 12C1.10085e-07 10.7408 0.1982 9.48939 0.587323 8.29179L2.48062 8.90696C2.15605 9.90588 1.99073 10.9497 1.99073 12H0Z'
              fill='#5F259F'
            />
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M9.04973 11.68C9.04973 13 9.19373 14.056 9.69773 14.884C10.2257 15.76 11.0177 16.216 11.9777 16.216C13.0577 16.216 14.0057 15.556 14.5097 14.38C14.8337 13.612 14.9417 12.712 14.9417 11.68C14.9417 10.648 14.8457 9.76 14.5097 8.992C14.0057 7.816 13.0577 7.168 11.9777 7.168C10.5737 7.168 9.52973 8.14 9.19373 9.868C9.07373 10.468 9.04973 11.08 9.04973 11.68ZM9.88973 11.692C9.88973 10.516 9.98573 9.616 10.3817 8.956C10.7537 8.332 11.3537 7.96 11.9897 7.96C13.2497 7.96 14.1377 9.172 14.1377 11.692C14.1377 14.224 13.2377 15.424 11.9897 15.424C11.3657 15.424 10.7537 15.076 10.3817 14.452C9.98573 13.792 9.88973 12.88 9.88973 11.692Z'
              fill='black'
            />
          </>
        );
      }
      case 1: {
        return (
          <>
            <path
              d='M4.94658 2.29179C5.96532 1.55164 7.0942 0.976443 8.2918 0.58732L8.90697 2.48062C7.90805 2.80519 6.96644 3.28496 6.1167 3.90233L4.94658 2.29179Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 4.94658C3.03195 3.92784 3.92785 3.03195 4.94658 2.29179L6.11671 3.90233C5.26697 4.5197 4.5197 5.26696 3.90233 6.1167L2.2918 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M0.587323 8.29179C0.976446 7.0942 1.55164 5.96531 2.2918 4.94657L3.90233 6.1167C3.28497 6.96643 2.80519 7.90804 2.48062 8.90696L0.587323 8.29179Z'
              fill='#5F259F'
            />
            <path
              d='M0 12C1.10085e-07 10.7408 0.1982 9.48939 0.587323 8.29179L2.48062 8.90696C2.15605 9.90588 1.99073 10.9497 1.99073 12H0Z'
              fill='#5F259F'
            />
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path d='M11.7377 8.224V16H12.6017V7.384H10.8977L10.3817 8.224H11.7377Z' fill='black' />
          </>
        );
      }
      case 2: {
        return (
          <>
            <path
              d='M2.2918 4.94658C3.03195 3.92784 3.92785 3.03195 4.94658 2.29179L6.11671 3.90233C5.26697 4.5197 4.5197 5.26696 3.90233 6.1167L2.2918 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M0.587323 8.29179C0.976446 7.0942 1.55164 5.96531 2.2918 4.94657L3.90233 6.1167C3.28497 6.96643 2.80519 7.90804 2.48062 8.90696L0.587323 8.29179Z'
              fill='#5F259F'
            />
            <path
              d='M0 12C1.10085e-07 10.7408 0.1982 9.48939 0.587323 8.29179L2.48062 8.90696C2.15605 9.90588 1.99073 10.9497 1.99073 12H0Z'
              fill='#5F259F'
            />
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M9.03773 16H14.8937V15.16H10.9097L13.0577 12.856C14.0777 11.752 14.7737 10.936 14.7737 9.76C14.7737 8.32 13.6697 7.168 12.1097 7.168C10.5017 7.168 9.28973 8.404 9.24173 10.084H10.0697C10.1777 8.764 10.9817 7.96 12.0737 7.96C13.1177 7.96 13.9337 8.764 13.9337 9.76C13.9337 10.696 13.3457 11.356 12.3377 12.448L9.03773 16Z'
              fill='black'
            />
          </>
        );
      }
      case 3: {
        return (
          <>
            <path
              d='M0.587323 8.29179C0.976446 7.0942 1.55164 5.96531 2.2918 4.94657L3.90233 6.1167C3.28497 6.96643 2.80519 7.90804 2.48062 8.90696L0.587323 8.29179Z'
              fill='#5F259F'
            />
            <path
              d='M0 12C1.10085e-07 10.7408 0.1982 9.48939 0.587323 8.29179L2.48062 8.90696C2.15605 9.90588 1.99073 10.9497 1.99073 12H0Z'
              fill='#5F259F'
            />
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M13.4897 9.388C13.4897 10.18 12.8657 10.744 11.4977 10.828V11.62C12.0497 11.644 12.5657 11.68 13.0577 11.944C13.6577 12.268 14.0177 12.856 14.0177 13.492C14.0177 14.488 13.2017 15.376 11.9417 15.376C10.8257 15.376 10.2377 14.788 9.94973 13.696H9.09773C9.40973 15.364 10.4417 16.216 11.9297 16.216C13.7177 16.216 14.8577 14.872 14.8577 13.432C14.8577 12.484 14.3057 11.572 13.2857 11.152C14.0177 10.72 14.3897 10.12 14.3897 9.388C14.3897 8.164 13.2977 7.168 11.9057 7.168C10.7057 7.168 9.70973 7.9 9.38573 9.376H10.2617C10.5977 8.476 11.0777 8.008 11.9177 8.008C12.8537 8.008 13.4897 8.656 13.4897 9.388Z'
              fill='black'
            />
          </>
        );
      }
      case 4: {
        return (
          <>
            <path
              d='M0 12C1.10085e-07 10.7408 0.1982 9.48939 0.587323 8.29179L2.48062 8.90696C2.15605 9.90588 1.99073 10.9497 1.99073 12H0Z'
              fill='#5F259F'
            />
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.98973 13.996H13.1057V16H13.9697V13.996H15.0137V13.156H13.9697V7.168H13.7897L8.98973 13.996ZM10.5737 13.156L13.1057 9.58V13.156H10.5737Z'
              fill='black'
            />
          </>
        );
      }
      case 5: {
        return (
          <>
            <path
              d='M0.587322 15.7082C0.198199 14.5106 -1.10085e-07 13.2592 0 12H1.99073C1.99073 13.0503 2.15605 14.0941 2.48062 15.093L0.587322 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M10.8497 7.384L10.0577 11.656C10.6337 11.416 11.2217 11.188 11.8937 11.188C13.1297 11.188 13.9217 11.992 13.9217 13.156C13.9217 14.476 12.9617 15.412 11.8577 15.412C11.0777 15.412 10.2737 14.968 10.0577 13.912H9.16973C9.34973 15.232 10.3337 16.204 11.7977 16.204C13.6697 16.204 14.8217 14.848 14.8217 13.192C14.8217 11.608 13.7177 10.396 12.0977 10.396C11.6177 10.396 11.3057 10.492 11.0897 10.552L11.5097 8.224H14.5817V7.384H10.8497Z'
              fill='black'
            />
          </>
        );
      }
      case 6: {
        return (
          <>
            <path
              d='M2.2918 19.0534C1.55164 18.0347 0.976443 16.9058 0.58732 15.7082L2.48062 15.093C2.80519 16.092 3.28496 17.0336 3.90233 17.8833L2.2918 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M10.4657 11.068C9.85373 11.98 9.49373 12.772 9.49373 13.612C9.49373 14.968 10.5497 16.216 12.1097 16.216C13.5257 16.216 14.7977 15.172 14.7977 13.564C14.7977 12.172 13.7777 10.996 12.3497 10.996C11.9417 10.996 11.6777 11.08 11.4737 11.152L13.7897 7.624L13.0937 7.168L10.4657 11.068ZM12.1457 11.752C13.1537 11.752 13.9577 12.568 13.9577 13.564C13.9577 14.56 13.1417 15.376 12.1457 15.376C11.1497 15.376 10.3337 14.56 10.3337 13.564C10.3337 12.568 11.1497 11.752 12.1457 11.752Z'
              fill='black'
            />
          </>
        );
      }
      case 7: {
        return (
          <>
            <path
              d='M4.94658 21.7082C3.92784 20.968 3.03195 20.0722 2.2918 19.0534L3.90233 17.8833C4.5197 18.733 5.26697 19.4803 6.1167 20.0977L4.94658 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path d='M9.54173 8.224H13.6697L9.68573 15.856L10.3937 16.216L15.0017 7.384H9.54173V8.224Z' fill='black' />
          </>
        );
      }
      case 8: {
        return (
          <>
            <path
              d='M8.2918 23.4127C7.0942 23.0236 5.96531 22.4484 4.94657 21.7082L6.1167 20.0977C6.96643 20.715 7.90804 21.1948 8.90697 21.5194L8.2918 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M9.48173 9.412C9.48173 10.156 9.90173 10.828 10.7657 11.272C9.72173 11.8 9.09773 12.496 9.09773 13.6C9.09773 14.932 10.1057 16.204 11.9897 16.204C13.9217 16.204 14.9177 14.896 14.9177 13.528C14.9177 12.472 14.3417 11.8 13.2977 11.272C14.1137 10.828 14.5097 10.228 14.5097 9.436C14.5097 8.224 13.4657 7.168 12.0497 7.168C10.5857 7.168 9.48173 8.224 9.48173 9.412ZM12.0137 8.008C13.1057 8.008 13.6697 8.74 13.6697 9.4C13.6697 10.132 13.0097 10.912 12.0377 10.912C11.1857 10.912 10.3817 10.228 10.3817 9.424C10.3817 8.644 11.0777 8.008 12.0137 8.008ZM12.0497 11.704C13.2257 11.704 14.0777 12.628 14.0777 13.54C14.0777 14.536 13.2617 15.412 12.0017 15.412C10.7177 15.412 9.93773 14.572 9.93773 13.624C9.93773 12.652 10.8137 11.704 12.0497 11.704Z'
              fill='black'
            />
          </>
        );
      }
      case 9: {
        return (
          <>
            <path
              d='M12 24C10.7408 24 9.48939 23.8018 8.2918 23.4127L8.90697 21.5194C9.90589 21.8439 10.9497 22.0093 12 22.0093L12 24Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M13.5977 12.316C14.2097 11.404 14.5697 10.6 14.5697 9.772C14.5697 8.404 13.5137 7.168 11.9537 7.168C10.5257 7.168 9.27773 8.224 9.27773 9.82C9.27773 11.224 10.2857 12.388 11.7137 12.388C12.0737 12.388 12.3617 12.304 12.6017 12.232L10.2737 15.76L10.9817 16.216L13.5977 12.316ZM11.9177 11.632C10.9217 11.632 10.1177 10.816 10.1177 9.82C10.1177 8.812 10.9217 8.008 11.9177 8.008C12.9257 8.008 13.7297 8.824 13.7297 9.82C13.7297 10.816 12.9137 11.632 11.9177 11.632Z'
              fill='black'
            />
          </>
        );
      }
      case 10: {
        return (
          <>
            <path
              d='M15.7082 23.4127C14.5106 23.8018 13.2592 24 12 24L12 22.0093C13.0503 22.0093 14.0941 21.8439 15.093 21.5194L15.7082 23.4127Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM12.372 11.68C12.372 13 12.516 14.056 13.02 14.884C13.548 15.76 14.34 16.216 15.3 16.216C16.38 16.216 17.328 15.556 17.832 14.38C18.156 13.612 18.264 12.712 18.264 11.68C18.264 10.648 18.168 9.76 17.832 8.992C17.328 7.816 16.38 7.168 15.3 7.168C13.896 7.168 12.852 8.14 12.516 9.868C12.396 10.468 12.372 11.08 12.372 11.68ZM13.212 11.692C13.212 10.516 13.308 9.616 13.704 8.956C14.076 8.332 14.676 7.96 15.312 7.96C16.572 7.96 17.46 9.172 17.46 11.692C17.46 14.224 16.56 15.424 15.312 15.424C14.688 15.424 14.076 15.076 13.704 14.452C13.308 13.792 13.212 12.88 13.212 11.692Z'
              fill='black'
            />
          </>
        );
      }
      case 11: {
        return (
          <>
            <path
              d='M19.0534 21.7082C18.0347 22.4484 16.9058 23.0236 15.7082 23.4127L15.093 21.5194C16.092 21.1948 17.0336 20.715 17.8833 20.0977L19.0534 21.7082Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM15.06 8.224V16H15.924V7.384H14.22L13.704 8.224H15.06Z'
              fill='black'
            />
          </>
        );
      }
      case 12: {
        return (
          <>
            <path
              d='M21.7082 19.0534C20.968 20.0722 20.0722 20.9681 19.0534 21.7082L17.8833 20.0977C18.733 19.4803 19.4803 18.733 20.0977 17.8833L21.7082 19.0534Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM12.36 16H18.216V15.16H14.232L16.38 12.856C17.4 11.752 18.096 10.936 18.096 9.76C18.096 8.32 16.992 7.168 15.432 7.168C13.824 7.168 12.612 8.404 12.564 10.084H13.392C13.5 8.764 14.304 7.96 15.396 7.96C16.44 7.96 17.256 8.764 17.256 9.76C17.256 10.696 16.668 11.356 15.66 12.448L12.36 16Z'
              fill='black'
            />
          </>
        );
      }
      case 13: {
        return (
          <>
            <path
              d='M23.4127 15.7082C23.0236 16.9058 22.4484 18.0347 21.7082 19.0534L20.0977 17.8833C20.715 17.0336 21.1948 16.092 21.5194 15.093L23.4127 15.7082Z'
              fill='#5F259F'
            />
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM16.812 9.388C16.812 10.18 16.188 10.744 14.82 10.828V11.62C15.372 11.644 15.888 11.68 16.38 11.944C16.98 12.268 17.34 12.856 17.34 13.492C17.34 14.488 16.524 15.376 15.264 15.376C14.148 15.376 13.56 14.788 13.272 13.696H12.42C12.732 15.364 13.764 16.216 15.252 16.216C17.04 16.216 18.18 14.872 18.18 13.432C18.18 12.484 17.628 11.572 16.608 11.152C17.34 10.72 17.712 10.12 17.712 9.388C17.712 8.164 16.62 7.168 15.228 7.168C14.028 7.168 13.032 7.9 12.708 9.376H13.584C13.92 8.476 14.4 8.008 15.24 8.008C16.176 8.008 16.812 8.656 16.812 9.388Z'
              fill='black'
            />
          </>
        );
      }
      case 14: {
        return (
          <>
            <path
              d='M24 12C24 13.2592 23.8018 14.5106 23.4127 15.7082L21.5194 15.093C21.8439 14.0941 22.0093 13.0503 22.0093 12H24Z'
              fill='#5F259F'
            />
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM12.312 13.996H16.428V16H17.292V13.996H18.336V13.156H17.292V7.168H17.112L12.312 13.996ZM13.896 13.156L16.428 9.58V13.156H13.896Z'
              fill='black'
            />
          </>
        );
      }
      case 15: {
        return (
          <>
            <path
              d='M23.4127 8.2918C23.8018 9.48939 24 10.7408 24 12H22.0093C22.0093 10.9497 21.8439 9.90589 21.5194 8.90697L23.4127 8.2918Z'
              fill='#5F259F'
            />
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM14.172 7.384L13.38 11.656C13.956 11.416 14.544 11.188 15.216 11.188C16.452 11.188 17.244 11.992 17.244 13.156C17.244 14.476 16.284 15.412 15.18 15.412C14.4 15.412 13.596 14.968 13.38 13.912H12.492C12.672 15.232 13.656 16.204 15.12 16.204C16.992 16.204 18.144 14.848 18.144 13.192C18.144 11.608 17.04 10.396 15.42 10.396C14.94 10.396 14.628 10.492 14.412 10.552L14.832 8.224H17.904V7.384H14.172Z'
              fill='black'
            />
          </>
        );
      }
      case 16: {
        return (
          <>
            <path
              d='M21.7082 4.94658C22.4484 5.96532 23.0236 7.0942 23.4127 8.2918L21.5194 8.90697C21.1948 7.90805 20.715 6.96644 20.0977 6.1167L21.7082 4.94658Z'
              fill='#5F259F'
            />
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM13.788 11.068C13.176 11.98 12.816 12.772 12.816 13.612C12.816 14.968 13.872 16.216 15.432 16.216C16.848 16.216 18.12 15.172 18.12 13.564C18.12 12.172 17.1 10.996 15.672 10.996C15.264 10.996 15 11.08 14.796 11.152L17.112 7.624L16.416 7.168L13.788 11.068ZM15.468 11.752C16.476 11.752 17.28 12.568 17.28 13.564C17.28 14.56 16.464 15.376 15.468 15.376C14.472 15.376 13.656 14.56 13.656 13.564C13.656 12.568 14.472 11.752 15.468 11.752Z'
              fill='black'
            />
          </>
        );
      }
      case 17: {
        return (
          <>
            <path
              d='M19.0534 2.2918C20.0722 3.03195 20.9681 3.92784 21.7082 4.94658L20.0977 6.1167C19.4803 5.26697 18.733 4.5197 17.8833 3.90233L19.0534 2.2918Z'
              fill='#5F259F'
            />
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM12.864 8.224H16.992L13.008 15.856L13.716 16.216L18.324 7.384H12.864V8.224Z'
              fill='black'
            />
          </>
        );
      }
      case 18: {
        return (
          <>
            <path
              d='M15.7082 0.587322C16.9058 0.976445 18.0347 1.55164 19.0534 2.2918L17.8833 3.90233C17.0336 3.28497 16.092 2.80519 15.093 2.48062L15.7082 0.587322Z'
              fill='#5F259F'
            />
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM12.804 9.412C12.804 10.156 13.224 10.828 14.088 11.272C13.044 11.8 12.42 12.496 12.42 13.6C12.42 14.932 13.428 16.204 15.312 16.204C17.244 16.204 18.24 14.896 18.24 13.528C18.24 12.472 17.664 11.8 16.62 11.272C17.436 10.828 17.832 10.228 17.832 9.436C17.832 8.224 16.788 7.168 15.372 7.168C13.908 7.168 12.804 8.224 12.804 9.412ZM15.336 8.008C16.428 8.008 16.992 8.74 16.992 9.4C16.992 10.132 16.332 10.912 15.36 10.912C14.508 10.912 13.704 10.228 13.704 9.424C13.704 8.644 14.4 8.008 15.336 8.008ZM15.372 11.704C16.548 11.704 17.4 12.628 17.4 13.54C17.4 14.536 16.584 15.412 15.324 15.412C14.04 15.412 13.26 14.572 13.26 13.624C13.26 12.652 14.136 11.704 15.372 11.704Z'
              fill='black'
            />
          </>
        );
      }
      case 19: {
        return (
          <>
            <path
              d='M12 0C13.2592 1.50161e-08 14.5106 0.198199 15.7082 0.587322L15.093 2.48062C14.0941 2.15605 13.0503 1.99073 12 1.99073V0Z'
              fill='#5F259F'
            />
            <path
              d='M8.41547 8.224V16H9.27947V7.384H7.57547L7.05947 8.224H8.41547ZM16.92 12.316C17.532 11.404 17.892 10.6 17.892 9.772C17.892 8.404 16.836 7.168 15.276 7.168C13.848 7.168 12.6 8.224 12.6 9.82C12.6 11.224 13.608 12.388 15.036 12.388C15.396 12.388 15.684 12.304 15.924 12.232L13.596 15.76L14.304 16.216L16.92 12.316ZM15.24 11.632C14.244 11.632 13.44 10.816 13.44 9.82C13.44 8.812 14.244 8.008 15.24 8.008C16.248 8.008 17.052 8.824 17.052 9.82C17.052 10.816 16.236 11.632 15.24 11.632Z'
              fill='black'
            />
          </>
        );
      }
      case 20: {
        return (
          <>
            <path
              d='M5.71547 16H11.5715V15.16H7.58747L9.73547 12.856C10.7555 11.752 11.4515 10.936 11.4515 9.76C11.4515 8.32 10.3475 7.168 8.78747 7.168C7.17947 7.168 5.96747 8.404 5.91947 10.084H6.74747C6.85547 8.764 7.65947 7.96 8.75147 7.96C9.79547 7.96 10.6115 8.764 10.6115 9.76C10.6115 10.696 10.0235 11.356 9.01547 12.448L5.71547 16ZM12.372 11.68C12.372 13 12.516 14.056 13.02 14.884C13.548 15.76 14.34 16.216 15.3 16.216C16.38 16.216 17.328 15.556 17.832 14.38C18.156 13.612 18.264 12.712 18.264 11.68C18.264 10.648 18.168 9.76 17.832 8.992C17.328 7.816 16.38 7.168 15.3 7.168C13.896 7.168 12.852 8.14 12.516 9.868C12.396 10.468 12.372 11.08 12.372 11.68ZM13.212 11.692C13.212 10.516 13.308 9.616 13.704 8.956C14.076 8.332 14.676 7.96 15.312 7.96C16.572 7.96 17.46 9.172 17.46 11.692C17.46 14.224 16.56 15.424 15.312 15.424C14.688 15.424 14.076 15.076 13.704 14.452C13.308 13.792 13.212 12.88 13.212 11.692Z'
              fill='black'
            />
          </>
        );
      }
    }
  }
};
export default Countdown;
